import React from "react";
import Banner from "components/banner/banner";
import UseContext from "hooks/useContext";

const MAY_2026_YEAR = "2026";
const MAY_MONTHS = new Set(["05", "5"]);

const hasMay2026Payslip = (payslips) =>
    Array.isArray(payslips) &&
    payslips.some(
        (payslip) =>
            payslip.year === MAY_2026_YEAR && MAY_MONTHS.has(String(payslip.month))
    );

const MayPayslipBanner = ({ tempWorkerData }) => {
    const { tempData } = UseContext();
    const payslips = tempWorkerData?.payslip ?? tempData?.payslip;

    if (!hasMay2026Payslip(payslips)) {
        return null;
    }

    return (
        <div className="w-full shrink-0 px-4 py-3 bg-blue-50 border-b border-blue-100">
            <Banner type="info">
                Les virements pour la paie du mois de mai ont bien été effectués. Si votre
                salaire n'est pas encore visible, il s'agit d'un délai de traitement bancaire.
            </Banner>
        </div>
    );
};

export default MayPayslipBanner;
